(function () {
  var supportsIntersection = 'IntersectionObserver' in window;
  var observer;

  function parseBgset(str) {
    try {
      var candidates = [];
      if (!str) return candidates;
      var items = str.split(',');
      for (var i = 0; i < items.length; i++) {
        var item = items[i].trim();
        if (!item) continue;
        var parts = item.split(/\s+/);
        var url = parts[0];
        var w = 0, h = 0;
        for (var j = 1; j < parts.length; j++) {
          var p = parts[j];
          if (p.endsWith('w')) w = parseInt(p, 10) || w;
          else if (p.endsWith('h')) h = parseInt(p, 10) || h;
        }
        candidates.push({ url: url, w: w, h: h });
      }
      return candidates;
    } catch (e) {
      return [];
    }
  }

  function pickCandidate(candidates, el) {
    if (!candidates.length) return null;
    var width = el.clientWidth || (el.parentElement ? el.parentElement.clientWidth : 0) || window.innerWidth;
    var dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 1));
    var target = Math.round(width * dpr);
    candidates.sort(function (a, b) { return a.w - b.w; });
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].w >= target) return candidates[i];
    }
    return candidates[candidates.length - 1];
  }

  function dispatchLazyLoaded(el) {
    try {
      el.classList.add('lazyloaded');
      var evt = document.createEvent('Event');
      evt.initEvent('lazyloaded', true, true);
      el.dispatchEvent(evt);
    } catch (e) {}
  }

  function applyBg(el) {
    if (!el || el.dataset.bgset_applied === '1') return;
    var bgset = el.getAttribute('data-bgset');
    if (!bgset) return;
    var candidates = parseBgset(bgset);
    var cand = pickCandidate(candidates, el);
    if (!cand || !cand.url) return;

    var parentFit = el.getAttribute('data-parent-fit') || '';
    if (parentFit) {
      el.style.backgroundSize = parentFit;
      if (!el.style.backgroundPosition) el.style.backgroundPosition = 'center';
      if (!el.style.backgroundRepeat) el.style.backgroundRepeat = 'no-repeat';
    }
    el.style.backgroundImage = 'url("' + cand.url + '")';
    el.dataset.bgset_applied = '1';
    dispatchLazyLoaded(el);
  }

  function unveilOnIntersect(el) {
    if (!supportsIntersection) { applyBg(el); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          applyBg(entry.target);
          io.unobserve(entry.target);
        }
      }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.lazyload[data-bgset]');
    for (var i = 0; i < nodes.length; i++) unveilOnIntersect(nodes[i]);
  }

  function setupMutationObserver() {
    if (observer || !('MutationObserver' in window)) return;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;

          // If the added node itself is a lazy bg node, process it.
          if (node.matches && node.matches('.lazyload[data-bgset]')) {
            unveilOnIntersect(node);
          }

          // Also process any lazy bg nodes inside the added subtree.
          if (node.querySelectorAll) init(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setupMutationObserver();
    }, { once: true });
  } else {
    init();
    setupMutationObserver();
  }

  // Theme triggers this when filters UI is re-rendered; product grid may also be updated.
  document.addEventListener('theme:filters:init', function () { init(); });
})();
